/**
 * The identity's programmes, as `/v1/me/operators` lists them — 0332.
 *
 * The list is every programme the identity holds a profile with (deleted
 * ones left out), REJECTED and TERMINATED included, and says per row whether
 * the programme can be selected. Two readers, two questions:
 *
 *   - the Brands screen asks "have I already applied here?": every row;
 *   - the switcher and the closed programme page ask "what can I open?":
 *     the selectable rows only. Offering the rest led straight back into
 *     NO_ACTIVE_PROGRAMME.
 */

export interface ListedProgramme {
  readonly display_name: string;
  readonly selectable: boolean;
}

/** The Brands screen's "already joined": every listed programme, by name. */
export function joinedProgrammeNames(items: readonly ListedProgramme[]): Set<string> {
  return new Set(items.map((o) => o.display_name));
}

/** What the switcher and the closed programme page may offer. */
export function selectableProgrammes<T extends ListedProgramme>(items: readonly T[]): T[] {
  return items.filter((o) => o.selectable);
}
